function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M139.911,134.272a19.034,19.034,0,0,0-12.237-13.926,11.867,11.867,0,0,0,4.432-11.206A12.273,12.273,0,0,0,107.75,111a11.878,11.878,0,0,0,4.577,9.346,19.037,19.037,0,0,0-12.239,13.926,4,4,0,0,0,4.02,4.728h31.783A4,4,0,0,0,139.911,134.272ZM111.833,111A8.168,8.168,0,1,1,120,119,8.094,8.094,0,0,1,111.833,111Zm21.292,24H106.876a1.99,1.99,0,0,1-1.923-2.676C107.425,126.4,113.234,123,120,123s12.576,3.4,15.047,9.324A1.989,1.989,0,0,1,133.125,135Z",
  transform: "translate(-100 -99)"
});

var SvgIconPolicy = function SvgIconPolicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPolicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-policy.c14dad5f.svg";
export { ForwardRef as ReactComponent };